import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import API from 'api.js';
import SelectOption from "components/PracticeMaterial/SelectOption";

import multiLing from "assets/images/images_new/translation-icon.png";

export default function TranslateModal(props) {

	const { isOpen, toggle, question, question_id, languages, voices } = props;

	const [question_text, setQuestionText] = useState(question);
	const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [isError, setIsError] = useState(false)


	const selectScriptLanguage = (selectedValue) => {
    setIsError(false)
		if (selectedValue !== "English" && selectedValue !== "0") {
			setQuestionText("Translating text. Please wait...");

			API({
				url: 'translate/sentence',
				method: 'POST',
				data: {
					script: question,
					lang: selectedValue,
					question_id: question_id
				}
			}).then((res) => {

				if (res.status === 200) {

					if (typeof res.data.translation === "object") {
						setQuestionText(res.data.translation.translation);
					} else {
						setQuestionText(res.data.translation);
					}
				} else {
					setQuestionText(res.message);
				}

				setSelectedLanguage(selectedValue);
				
			}).catch((err)=>{
        console.log("err",err.response.data.message);
        setIsError(true)
        setQuestionText(err.response.data.message)
      })
		} else {
			setSelectedLanguage("English");
			setQuestionText(question);
		}
	}

	return (
    <Modal show={isOpen} centered size="lg" className="text-translate-modal">
      <Modal.Header className="d-flex">
        <Modal.Title className="text-translation popup_heading m-0">
          <div className="modal-header-img">
            <img src={multiLing} alt="multi-languages" />
          </div>{" "}
          Text Translation
        </Modal.Title>

        <Button
          variant="link"
          className="modalClose-Btn p-0"
          onClick={() => toggle(false)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div>
          <h2 className="translate-title">Language</h2>
          <div className="col-6 col-sm-6 col-md-4 col-lg-3 p-0">
            {languages.length > 0 &&
              <SelectOption
                isClearable={false}
                selected={selectedLanguage}
                data={languages.filter((language, i) => {
                  return language.label !== selectedLanguage;
                })}
                changeEvent={selectScriptLanguage}
              />
            }
          </div>
        </div>
        <div className="text-to-translate">
          <div className={`mb-2 ques-text ${isError ? "text-danger" : ""}`}>{question_text}</div>
        </div>
      </Modal.Body>
    </Modal>
  );
}